import { useIsEditingCanvasInWorkspacePanel } from '~/components/v2/components/shared/panel/useIsEditingCanvasInWorkspacePanel';
import { useWorkspaceRightPanelOpen } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelOpen';
import { useWorkspaceRightPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelStore';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { useHasCurrentWorkspaceProvider } from '~/providers/CurrentWorkspaceProvider';

/** True when the canvas split layout is active and the middle panel can be collapsed. */
export const useShowWorkspaceSplitTopbar = () => {
  const isPrivateWorkspace = useHasCurrentWorkspaceProvider();
  const { generativeCanvasEnabled } = useTemporaryFeatureFlags();
  const isRightPanelOpen = useWorkspaceRightPanelOpen();
  const boardViewCollapsed = useWorkspaceRightPanelStore((state) => state.boardViewCollapsed);
  const isFullscreen = useWorkspaceRightPanelStore((state) => state.isFullscreen);
  const isEditingCanvas = useIsEditingCanvasInWorkspacePanel();

  return (
    isPrivateWorkspace &&
    generativeCanvasEnabled &&
    isRightPanelOpen &&
    isEditingCanvas &&
    !boardViewCollapsed &&
    !isFullscreen
  );
};
